import { LocalStorageEntities } from '@/constants/LocalStorageEntities';
import { useLocalStorage } from '@vueuse/core';
import type { Ref } from 'vue';

/**
 * This boolean is designed to temporarily disable the limited functionality of the platform when an
 * admin is impersonating an account with limited permissions (originally faux whitelabel, now separated
 * into several types of permission: isReadOnlyPlatform, shouldFactorDecompositionBeVisible,
 * shouldPreventStrategyFactsheetAccess, canSwitchPortfolios, canSeeMyLab, canSeeInsights).
 */
export const useAdminBackdoor = function (): Ref<boolean> {
  return useLocalStorage(LocalStorageEntities.SHOULD_USE_ADMIN_BACK_DOOR, false);
};
